export default "__VITE_ASSET__uGNE80o$__"